import React, { useRef } from 'react';
import { useDateSegment } from 'react-aria/useDateField';
import {
  DateFieldState,
  DateSegment as DateSegmentType,
} from 'react-stately/useDateFieldState';
import styles from '@danske/sapphire-css/components/dateField/dateField.module.css';
import clsx from 'clsx';
import { setPlaceholderLanguage } from './utils/segments';
import { useLocale } from 'react-aria/I18nProvider';

export interface DateSegmentProps {
  segment: DateSegmentType;
  state: DateFieldState;
}

export const DateSegment = ({
  segment,
  state,
}: DateSegmentProps): React.JSX.Element =>
  segment.type === 'literal' ? (
    <SeparatorSegment segment={segment} />
  ) : (
    <EditableSegment segment={segment} state={state}></EditableSegment>
  );

const SeparatorSegment = ({ segment }: { segment: DateSegmentType }) => (
  <span
    aria-hidden="true"
    className={clsx(
      styles['sapphire-date-field__segment'],
      styles['sapphire-date-field__segment--separator']
    )}
  >
    {segment.text}
  </span>
);

const EditableSegment = ({ segment, state }: DateSegmentProps) => {
  const ref = useRef(null);
  const { segmentProps } = useDateSegment(segment, state, ref);
  const { locale } = useLocale();
  const segmentWithTranslatedPlaceholders = setPlaceholderLanguage(
    segment,
    locale
  );

  return (
    <div
      {...segmentProps}
      style={segmentProps.style}
      ref={ref}
      className={clsx(styles['sapphire-date-field__segment'], {
        [styles['sapphire-date-field__segment--filled']]:
          !segmentWithTranslatedPlaceholders.isPlaceholder,
      })}
    >
      {segmentWithTranslatedPlaceholders.text}
    </div>
  );
};
